import axios from 'axios'

export default {
    name: 'transaction',
    actions: {
        cancelTransaction(store, { auth, data }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + "main/cancel_transaction",
                    params: {
                        tlc: auth.username,
                    },
                    data: data,
                    auth: {
                        username: auth.username,
                        password: auth.password
                    },
                    headers: {
                        "X-API-KEY": auth.apikey
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        closeTransaction(store, { auth, data, url }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + url,
                    params: {
                        tlc: auth.username,
                    },
                    data: data,
                    auth: {
                        username: auth.username,
                        password: auth.password
                    },
                    headers: {
                        "X-API-KEY": auth.apikey
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        axiosStoreGet(store, { auth, url, params }) {
            return new Promise((resolve, reject) => {
                axios({
                method: "get",
                url:
                    process.env.VUE_APP_SERVICEURL + url,
                params:params,
                auth: {
                    username: auth.username,
                    password: auth.password,
                },
                headers: {
                    "X-API-KEY": auth.apikey,
                },
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
            });
        },
        axiosStorePublicPost(store, { url, params }) {
            //console.log(url, params)
            return new Promise((resolve, reject) => {
                axios({
                method: "post",
                url:
                    process.env.VUE_APP_SERVICEURL + url,
                data:params,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
            });
        },
    }
}